import { IconButton, Stack, Tooltip } from '@mui/material';
import { alpha } from '@mui/material/styles';

const buttons = [
  {
    icon: 'fa-brands fa-facebook',
    tooltip: 'Facebook',
    href: `https://www.facebook.com/dialog/share?app_id=741048509750318&display=popup&href=${encodeURIComponent(window.location.href)}&redirect_uri=${encodeURIComponent(
      window.location.href,
    )}`,
  },
  {
    icon: 'fa-brands fa-whatsapp',
    tooltip: 'Whatsapp',
    href: `https://wa.me/?text=${encodeURIComponent(window.location.href)}`,
  },
  {
    icon: 'fa-brands fa-twitter',
    tooltip: 'Twitter',
    href: `https://twitter.com/intent/tweet?text=${encodeURIComponent(window.location.href)}`,
  },

  {
    icon: 'fa-regular fa-envelope',
    tooltip: 'Email',
    href: `mailto:?body=${encodeURIComponent(window.location.href)}`,
  },
];

export default function ShareButtons() {
  return (
    <Stack direction="row">
      {buttons.map((item) => (
        <Tooltip key={item.icon} title={item.tooltip}>
          <IconButton
            component="a"
            rel="noreferrer"
            target="_blank"
            href={item.href}
            sx={{
              color: 'gray',
              '&:hover': {
                color: 'black',
                background: alpha('#000', 0.1),
                textDecoration: 'none',
              },
            }}
          >
            <i className={item.icon} style={{ fontSize: '16px' }} />
          </IconButton>
        </Tooltip>
      ))}
    </Stack>
  );
}
